module.exports = __webpack_public_path__ + "img/vpn.8f043def.jpg";